<template>
	<page style="height: 100vh; padding: 0; user-select: none;">
		<module enable-flex>
			<div class="decorate-head flex-between-center">
				<img class="logo" :src="require(`./static/decorate_logo_${type}.png`)" alt="">
				<sub-button v-if="type == 'pc'" width="60" height="36" font-size="14" color="gray" hollow @click="previewHandle">预览</sub-button>
			</div>
			<div class="flex-grow flex">
				<div v-if="dragUnitList.length" class="decorate-unit">
					<div class="decorate-unit-scroll">
						<div v-for="(item, i) in dragUnitList" :key="i" v-if="item.load_type != 2" class="item flex-column flex-center" @mousedown="dragHandle($event, item)">
							<img :src="require(`@/submodule/decorate_manage/static/icon/decorate_unit_${item.control_code}.png`)" alt="">
							<p>{{item.control_name}}</p>
						</div>
					</div>
				</div>
				<div v-if="dragUnitPosition" class="decorate-unit-drag flex-column flex-center" :style="{'left': dragUnitPosition.x + 'px', 'top': dragUnitPosition.y + 'px'}">
					<img :src="require(`@/submodule/decorate_manage/static/icon/decorate_unit_${dragUnit.control_code}.png`)">
					<p>{{dragUnit.control_name}}</p>
				</div>
				
				<div class="flex-grow flex-column">
					<div class="decorate-handle flex-center-cross">
						<div class="page-handle flex-center">
							<label>当前页面</label>
							<dl class="page-list">
								<dt class="flex-between-center">
									<span>{{currentPageData.page_name}}</span>
									<i class="sf sf-tri-down"></i>
								</dt>
								<dd>
									<div class="title flex-between-center">
										<p>全部页面</p>
										<sub-button color="gray" hollow @click="editPage()">新建页面</sub-button>
									</div>
									<div class="list flex">
										<div class="item">
											<p>系统页</p>
											<ul>
												<template v-for="(item, i) in pageList">
													<li v-if="item.page_type == 1" :key="i" class="flex-between-center" :class="{'z-crt': currentPage == item.page_id}">
														<a class="flex-grow" @click="currentPage = item.page_id">{{item.page_name}}</a>
														
														<div class="handle">
															<a class="s-link" title="编辑" @click="editPage(item)"><i class="sf sf-edit"></i></a>
														</div>
													</li>
												</template>
											</ul>
										</div>
										<div class="item">
											<p>自定义页</p>
											<ul>
												<template v-for="(item, i) in pageList">
													<li v-if="item.page_type == 2" :key="i" class="flex-between-center" :class="{'z-crt': currentPage == item.page_id}" :title="item.remark">
														<a class="flex-grow" @click="currentPage = item.page_id">{{item.page_name}}</a>
													
														<div class="handle">
															<a class="s-link" title="编辑" @click="editPage(item)"><i class="sf sf-edit"></i></a>
															<a class="s-link" title="复制页面" @click="editPage(item, true)"><i class="sf sf-copy"></i></a>
															<a class="s-link" title="删除" @click="deletePageHandle(item)"><i class="sf sf-trash"></i></a>
														</div>
													</li>
												</template>
											</ul>
										</div>
									</div>
								</dd>
							</dl>
						</div>
						<a class="page-config" @click="backgroundConfig"><i class="sf">&#xe630;</i>页面设置</a>
						<a v-if="type == 'pc'" class="page-config" @click="$refs.navList.open('导航管理', id)"><i class="sf">&#xe64b;</i>导航管理</a>
					</div>
					<div class="decorate-preview-box flex-grow">
						<preview class="decorate-preview" :page="currentPageData" :type="type" :unit-list="unitList" :style="previewStyle"></preview>
					</div>
				</div>
			</div>
		</module>
		
		<sub-dialog ref="editPage" :title="copyState ? `复制页面【${copyState}】` : editState ? '编辑页面' : '新增页面'" width="500" @resolve="editPageHandle">
			<sub-form ref="editPageForm">
				<sub-form-item type="hidden" name="template_id"></sub-form-item>
				<sub-form-item type="hidden" name="page_id"></sub-form-item>
				<sub-form-item type="hidden" name="old_page_id"></sub-form-item>
				<sub-form-item type="input" label="页面名称" name="page_name" required></sub-form-item>
				<sub-form-item type="input" label="备注" name="remark"></sub-form-item>
			</sub-form>
		</sub-dialog>
		
		<sub-dialog ref="backgroundConfig" title="设置页面背景" width="650" @resolve="backgroundConfigHandle">
			<sub-form ref="backgroundConfigForm">
				<sub-form-item type="color" label="页面背景色" name="bgColor"></sub-form-item>
				<sub-form-item type="image" label="页面背景图" name="bgImg" oss :file-word="`建议图片尺寸：宽度${type == 'pc' ? '1920' : '750'}像素，高度任意`"></sub-form-item>
				<sub-form-item v-show="type == 'app' && currentPageData.page_type == 1" type="image" label="浅色LOGO图片" name="whiteTitleImg" oss file-word="建议图片尺寸：宽度任意，高度108像素"></sub-form-item>
				<sub-form-item v-show="type == 'app' && currentPageData.page_type == 1" type="image" label="深色LOGO图片" name="titleImg" oss file-word="建议图片尺寸：宽度任意，高度108像素"></sub-form-item>
				<sub-form-item v-show="type == 'app' && currentPageData.page_type == 1" type="radio" label="UI主题色" name="uiTheme" :options="UIThemeList"></sub-form-item>
			</sub-form>
		</sub-dialog>

		<nav-list ref="navList"></nav-list>
	</page>
</template>

<script>
	import preview from './components/preview.vue'
	import navList from './pc_nav_list.vue'
	import {createStore, mapState, updateState} from '@/submodule/components/createStore.js'
	
	createStore('decorate', {
		dragUnit: false,
		dragUnitPosition: false
	});
	
	export default {
		name: 'decorate_manage',
		
		components: {
			preview,
			navList
		},
		
		props: {
			type: String,
			id: String
		},
		
		data() {
			return {
				pageList: [],
				currentPage: '',
				editState: false,
				copyState: false,
				
				dragUnitList: [],
				unitList: [],
				
				backgroundData: {},
				UIThemeList: [{
					name: '深色',
					value: '1'
				}, {
					name: '浅色',
					value: '2'
				}]
			}
		},
		
		computed: {
			...mapState('decorate', ['dragUnit', 'dragUnitPosition']),
			
			currentPageData() {
				return this.pageList.find(item => item.page_id == this.currentPage) || {};
			},
			
			previewStyle() {
				return {
					'min-width': this.type == 'pc' ? '1400px' : '375px',
					'width': this.type == 'pc' ? 'auto' : '375px',
					'background-color': this.backgroundData.bgColor || '#F5F5F5',
					'background-image': `url('${this.backgroundData.bgImg}')`,
					'background-position': `0 ${this.type == 'pc' ? '0' : '-180px'}`
				}
			}
		},
		
		watch: {
			id() {
				this.unitList = [];
				this.getPageList();
			},
			
			currentPage(val) {
				if (val) {
					this.getDragUnitList();
					this.getUnitList();
					this.getBackground();
				}
			}
		},
		
		created() {
			document.title = `${this.type == 'pc' ? 'PC' : '移动'}商城装修 - ${this.$store.state.systemConfig.oms_system_name || this.$store.state.systemConfig.scs_system_name}`
		},
		
		mounted() {
			this.getPageList();
			
			this.$bus.$on('updateUnitList', () => {
				this.getUnitList();
			});
		},
		
		methods: {
			getPageList(id) {
				this.request({
					url: '/decoration/page/list',
					data: {
						template_id: this.id
					},
					success: data => {
						this.pageList = data;
						
						this.$nextTick(() => {
							if (id && data.find(item => item.page_id == id)) {
								this.currentPage = id;
							} else if (!this.currentPage || !data.find(item => item.page_id == this.currentPage)) {
								this.currentPage = data[0].page_id;
							}
						});
					}
				});
			},
			
			getBackground() {
				this.request({
					url: '/decoration/page/detail',
					data: {
						page_id: this.currentPage
					},
					success: data => {
						this.backgroundData = JSON.parse(data.page_background || '{}');
					}
				});
			},
			
			getDragUnitList() {
				this.request({
					url: '/decoration/control/list',
					data: {
						template_id: this.id,
						page_type: this.currentPageData.page_type
					},
					success: data => {
						this.dragUnitList = data;
					}
				});
			},
			
			getUnitList() {
				this.request({
					url: '/decoration/page/layout',
					data: {
						template_id: this.id,
						page_id: this.currentPage
					},
					success: data => {
						this.unitList = data[0].control_list;
					}
				});
			},
			
			editPage(item, copy) {
				this.editState = !copy && !!item;
				this.copyState = copy ? item.page_name : '';
				this.$refs.editPageForm.clear();
				this.$refs.editPageForm.set(copy ? {
					old_page_id: item.page_id
				} : item || {
					template_id: this.id
				});
				this.$refs.editPage.open();
			},
			
			editPageHandle(stop, next) {
				stop();
				this.$refs.editPageForm.submit({
					url: this.copyState ? '/decoration/page/copy' : this.editState ? '/decoration/page/edit' : '/decoration/page/add',
					rule: {
						page_name: '请填写页面名称'
					},
					success: (data, res) => {
						next();
						this.getPageList(res);
					}
				});
			},
			
			deletePageHandle(item) {
				this.sub.$confirm({
					text: '确定要删除该页面吗？',
					resolve: () => {
						this.request({
							url: '/decoration/page/remove',
							data: {
								page_id: item.page_id
							},
							loading: true,
							success: data => {
								this.sub.$message({
									text: '删除成功'
								});
								this.getPageList();
							}
						});
					}
				});
			},
			
			backgroundConfig() {
				this.request({
					url: '/decoration/page/detail',
					data: {
						page_id: this.currentPage
					},
					loading: true,
					success: data => {
						data = JSON.parse(data.page_background || '{}');
						data.uiTheme = data.uiTheme || '1'
						this.$refs.backgroundConfigForm.clear();
						this.$refs.backgroundConfigForm.set(data);
						this.$refs.backgroundConfig.open();
					}
				});
			},
			
			backgroundConfigHandle(stop, next) {
				stop();
				this.$refs.backgroundConfigForm.submit({
					url: '/decoration/page/background/edit',
					dataFormatter: data => {
						return {
							page_id: this.currentPage,
							page_background: data
						}
					},
					success: () => {
						next();
						this.getBackground();
					}
				});
			},
			
			previewHandle() {
				window.open(`${this.$store.state.systemConfig.pc_mall_url}${this.currentPageData.page_type == 1 ? `?page_id=${this.currentPage}` : `channel/${this.currentPage}`}`);
			},
			
			dragHandle(e, module) {
				if (e.button != 0) return;
				
				updateState('decorate', 'dragUnit', module);
				
				this._dragMoveEvent = e => {
					updateState('decorate', 'dragUnitPosition', {
						x: e.clientX,
						y: e.clientY
					});
				};
				this._dragMoveEvent(e);
				this._dragEndEvent = () => {
					updateState('decorate', 'dragUnitPosition', false);
					window.removeEventListener('mousemove', this._dragMoveEvent);
					window.removeEventListener('mouseup', this._dragEndEvent);
				}
				window.addEventListener('mousemove', this._dragMoveEvent);
				window.addEventListener('mouseup', this._dragEndEvent);
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.decorate {
		&-head {
			height: 60px;
			border-bottom: 1px solid #ddd;
			padding: 0 24px;
			
			.logo {
				height: 45px;
			}
		}
		
		&-unit {
			box-sizing: border-box;
			width: 201px;
			border-right: 1px solid #ddd;
			padding: 0 15px;
			overflow: hidden;
			
			&-scroll {
				width: calc(100% + 35px);
				height: 100%;
				overflow: auto;
			}
			
			&-drag {
				box-sizing: border-box;
				z-index: 999;
				position: fixed;
				width: 80px;
				height: 80px;
				border: 1px dashed #737A7E;
				font-size: 12px;
				color: #333;
				background: #e0e7eb;
				opacity: .6;
				cursor: move;
				transform: translate(-50%,-50%);
				
				&:after {
					content: '';
					position: absolute;
					inset: 0;
				}
				
				img {
					height: 40px;
					margin-bottom: 5px;
				}
			}
			
			.item {
				float: left;
				box-sizing: border-box;
				width: 80px;
				height: 80px;
				margin-top: 15px;
				font-size: 12px;
				color: #333;
				cursor: pointer;
				
				&:nth-child(even) {
					margin-left: 10px;
				}
				
				&:hover {
					border: 1px dashed #ddd;
					background: #F5F5F5;
				}
				
				img {
					height: 40px;
					margin-bottom: 5px;
				}
			}
		}
		
		&-handle {
			height: 50px;
			border-bottom: 1px solid #ddd;
			padding: 0 15px;
			background: #F0F4F6;
			
			.page {
				&-handle {
					label {
						margin-right: 8px;
						font-size: 13px;
						color: #666;
					}
				}
				
				&-list {
					z-index: 11;
					position: relative;
					
					&:hover {
						dd {
							display: block;
						}
					}
					
					dt {
						box-sizing: border-box;
						width: 190px;
						height: 34px;
						border: 1px solid #ddd;
						border-radius: 17px;
						padding: 0 12px 0 16px;
						font-size: 13px;
						background: #fff;
						
						.sf {
							font-size: 12px;
						}
					}
					
					dd {
						display: none;
						position: absolute;
						top: 33px;
						left: 0;
						box-sizing: border-box;
						width: 600px;
						border: 1px solid #ddd;
						background: #fff;
						
						.title {
							height: 50px;
							border-bottom: 1px solid #eee;
							padding: 0 10px;
							
							p {
								font-size: 13px;
								color: #666;
							}
						}
						
						.list {
							.item {
								width: 45%;
								height: 200px;
								padding: 10px 0 20px;
								overflow: auto;
								
								&:nth-child(2) {
									width: 55%;
									background: #FAFAFA;
								}
								
								p {
									line-height: 28px;
									font-weight: bold;
									text-indent: 24px;
									color: #333;
								}
								
								ul {
									position: relative;
									padding-top: 4px;
									padding-left: 58px;
									
									&:before {
										content: '';
										display: block;
										position: absolute;
										left: 33px;
										bottom: 14px;
										top: 0;
										width: 1px;
										background: #ddd;
									}
									
									li {
										position: relative;
										height: 30px;
										padding-right: 16px;
										font-size: 13px;
										
										&.z-crt {
											&:before {
												content: '\e63f';
												display: block;
												width: 16px;
												height: 16px;
												border-radius: 100%;
												margin-right: 6px;
												line-height: 18px;
												font-family: 'sub_iconfont';
												font-size: 12px;
												text-align: center;
												color: #fff;
												background: #004EDC;
											}
											
											> a {
												color: #004EDC;
											}
										}
										
										&:not(.z-crt) {
											> a {
												color: #666;
												
												&:hover {
													text-decoration: underline;
													color: #000;
												}
											}
										}
										
										&:hover {
											.handle {
												display: flex;
											}
										}
										
										&:after {
											content: '';
											position: absolute;
											left: -24px;
											top: 15px;
											width: 20px;
											height: 1px;
											background: #ddd;
										}
										
										.handle {
											display: none;
											
											a {
												margin-left: 8px;
											}
										}
									}
								}
							}
						}
					}
				}
				
				&-config {
					margin-left: 24px;
					font-size: 13px;
					
					&:hover {
						color: #004EDC;
					}
					
					.sf {
						margin-right: 5px;
					}
				}
			}
			
			.select {
				width: 200px;
				height: 36px;
			}
			
			.c-button {
				&:nth-child(n+2) {
					margin-left: 12px;
				}
			}
		}
		
		&-preview {
			margin: 0 auto;
			overflow: hidden;
			background-size: 100% auto;
			background-repeat: no-repeat;
			
			&-box {
				overflow: auto;
			}
		}
	}
</style>